<template>
  <div class="cui-header__top fixed-top-nav">
    <img class="logo" src="@/assets/images/ArcelorMittal_logo.png" alt="AMTB Demo">
    <div class="cui-header__search-container ng-pristine ng-untouched ng-valid ng-empty" v-if="base.accessByAnyAdmin()">
        <a><svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" class="cui-header__search-icon" viewBox="0 0 48 48">
                    <use xlink:href="node_modules/@covisint/cui-icons/dist/icons/icons-out.svg#search"></use>
                </svg>
        </a>
    </div>
  <div class="cui-profile" v-if="getUserData">
    <!-- Logged In User Name -->
    <div id="popover-reactive-1">
      <span class="cui-profile__user-name hidden-sm-and-down">{{getUserData.user.name.given}} {{getUserData.user.name.surname}}</span>
    <v-menu
        bottom
        min-width="200px"
        rounded
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            x-large
            v-on="on"
          >
            <v-avatar color="#00667c">
              <span style="color:white">{{getUserData.user.name.given | firstChar}}{{getUserData.user.name.surname | firstChar}}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-card flat>
              <v-btn
                text
                @click="signOut"
                class="w-100"
              >
              LogOut <v-icon> mdi-logout-variant </v-icon>
              </v-btn>
        </v-card>
      </v-menu>
  </div>
  </div>
  </div>
</template>
<script>
import Auth from '@/plugins/Auth'
import Avatar from 'vue-avatar'
import VueDropdown from 'vue-dynamic-dropdown'
import dropdown from '@/components/partials/Menus/dropdown'
import Base from '../../plugins/factory/BaseExtensions'
import store from '../../store/index'

export default {
  computed: {
    isUserLoggedIn () {
      return this.$store.getters.isAuth
    },
    getUserData () {
      return this.$store.getters.getUserInfo
    }
  },
  components: {
    Avatar,
    VueDropdown,
    'dropdown': dropdown
  },
  data () {
    return {
      base: Base,
      userInfo: null,
      userData: null,
      pendingApps: [],
      userAppRequestsCount: 0,
      userRegistrationRequestsCount: 0,
      orgRegistrationRequestsCount: 0,
      orgAppRequestsCount: 0,
      totalCount: 0,
      user: {
        initials: 'JD',
        fullName: 'John Doe',
        email: 'john.doe@doe.com'
      }
    }
  },
  methods: {
    signOut () {
      Auth.signOut()
    },
    navContentOpen () {
      let userDeatils = JSON.parse(localStorage.getItem('userData'))
      var pendingContentWrapper = this.$refs.pendingContentWrapper
      if (pendingContentWrapper.classList.contains('pending-content_wrapper_open')) {
        pendingContentWrapper.classList.remove('pending-content_wrapper_open')
      } else {
        pendingContentWrapper.classList.add('pending-content_wrapper_open')
      }
      if (!this.base.isOrgAdmin()) {
        this.$API.getPersonPendingApps({ personId: userDeatils.user.id })
          .then((res) => {
            this.pendingApps = res.map(x => x.name)
            store.dispatch('setUserPendingApps', this.pendingApps)
          }).fail(err => {
            console.log('err', err)
          })
      } else {
        let apiPromises = []
        apiPromises.push(this.$API.getPackageRequestsCount())
        if (this.base.accessToSecurityAndExchangeAdmins()) {
          apiPromises.push(
            this.$API.getRegistrationRequestsCount(),
            this.$API.getOrgRegistrationRequestsCount(),
            this.$API.getPackageRequestsCount({ qs: [['requestor.id', userDeatils.user.organization.id], ['requestor.type', 'organization']] })
          )
        }
        Promise.all(apiPromises)
          .then(res => {
            this.userAppRequestsCount = res[0]
            if (this.base.accessToSecurityAndExchangeAdmins()) {
              this.userRegistrationRequestsCount = res[1]
              this.orgRegistrationRequestsCount = res[2]
              this.orgAppRequestsCount = res[3]
              this.totalCount = res[0] + res[1] + res[2] + res[3]
            } else {
              this.totalCount = res[0]
            }
            store.dispatch('setUserAppDeatils', this.userAppRequestsCount, this.userRegistrationRequestsCount, this.orgRegistrationRequestsCount, this.orgAppRequestsCount, this.totalCount)
          }).catch(err => {
            console.log(err, 'err')
          })
      }
    },
    closenavContent () {
      var pendingContentWrapper = this.$refs.pendingContentWrapper
      pendingContentWrapper.classList.remove('pending-content_wrapper_open')
    }
  }
}
</script>
<style lang="scss">
.cui-header__top {
  border-bottom: 4px solid #FF3700;
  padding:8px 30px;
  .cui-profile__user-name{
    color:#666;
  }
}
.fixed-top-nav{
  position: sticky;
  background: #fff;
  z-index: 999;
  top:0
}
</style>



// WEBPACK FOOTER //
// src/components/core/Header.vue